import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';
import { BranchesService } from 'src/app/super-management/branch/branches.service';
import { UsersService } from 'src/app/super-management/user/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-close-branch',
  templateUrl: './close-branch.component.html',
  styleUrls: ['./close-branch.component.css'],
  host: {
    class: 'fill-screen-modal-phone'
  }
})
export class CloseBranchComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;
  isLoadingUpdates = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;
  private phoneUpdatedSub: Subscription;

  printingService: string;
  branch: string;
  close_msg: string;
  isPicsPrinter: boolean = false;
  branchId: string = null;
  
  updateRequested: boolean = false;
  userPhone: string = '';
  branchName: string = '';
  private pendingUpdateRequest: boolean = false;

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    private branchesService: BranchesService,
    private usersService: UsersService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.printingService = data.service;
    this.branch = data.branch;
    this.close_msg = data.close_msg;
    this.isPicsPrinter = data.isPicsPrinter;
    this.branchId = data.branchId || null;
    this.branchName = data.branch || '';
  }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    // Load user phone number
    if (this.userId) {
      this.usersService.getUser(this.userId).subscribe(
        (user: any) => {
          if (user && user.phone) {
            this.userPhone = this.formatPhoneNumber(user.phone);
          }
        },
        (error) => {
          console.error('Error loading user phone:', error);
        }
      );
    }

    // Subscribe to phone updates
    this.phoneUpdatedSub = this.usersService.phoneUpdated.subscribe((phone: number) => {
      if (phone) {
        this.userPhone = this.formatPhoneNumber(phone);
        // If there was a pending update request, try again
        if (this.pendingUpdateRequest) {
          this.pendingUpdateRequest = false;
          // Wait a bit for the phone to be saved
          setTimeout(() => {
            this.onRequestUpdateWhenBranchOpens();
          }, 500);
        }
      }
    });

    this.isLoading = false;
  }

  closeCloseBranchDialog() {
    this.dialogService.onCloseCloseBranchDialog();
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
    if (this.phoneUpdatedSub) {
      this.phoneUpdatedSub.unsubscribe();
    }
  }

  getPrintingService() {
    if (this.printingService === "express") {
      return "express";
    } else {
      return "plotter";
    }
  }

  formatPhoneNumber(phone: string | number): string {
    if (!phone) return '';
    let phoneStr = phone.toString().replace(/\D/g, '');
    
    // אם הטלפון הוא 9 ספרות (ללא 0), הוסף 0 בהתחלה
    if (phoneStr.length === 9) {
      phoneStr = '0' + phoneStr;
    }
    
    // אם הטלפון הוא 10 ספרות ומתחיל ב-0, עיצב אותו
    if (phoneStr.length === 10 && phoneStr.startsWith('0')) {
      return `${phoneStr.substring(0, 3)}-${phoneStr.substring(3, 7)}-${phoneStr.substring(7)}`;
    }
    
    return phoneStr;
  }

  onRequestUpdateWhenBranchOpens() {
    if (!this.branchId || !this.userId || !this.printingService) {
      console.error('[CLOSE-BRANCH-DIALOG] Missing required data:', {
        branchId: this.branchId,
        userId: this.userId,
        printingService: this.printingService
      });
      return;
    }

    // Check if user has phone number
    if (!this.userPhone || this.userPhone === '') {
      // Mark that we have a pending update request
      this.pendingUpdateRequest = true;
      // Open phone dialog
      this.dialogService.onOpenPhoneDialog();
      return;
    }

    this.isLoadingUpdates = true;
    
    console.log('[CLOSE-BRANCH-DIALOG] User requested update when branch opens:', {
      branchId: this.branchId,
      userId: this.userId,
      printingService: this.printingService
    });

    this.branchesService.requestUpdateWhenBranchOpens(
      this.printingService,
      this.branchId,
      this.userId
    ).subscribe(
      (response) => {
        console.log('[CLOSE-BRANCH-DIALOG] Update request successful:', response);
        this.isLoadingUpdates = false;
        this.updateRequested = true;
      },
      (error) => {
        console.error('[CLOSE-BRANCH-DIALOG] Update request failed:', error);
        this.isLoadingUpdates = false;
        // Error dialog should appear automatically via error-interceptor
      }
    );
  }

  onEditPhone() {
    this.dialogService.onOpenPhoneDialog();
  }
  // ===============
}
